import user from './user';
import ui from './ui';
import logic from './logic';

export default {
  ...user,
  ...ui,
  ...logic,
};
